import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import AutoBindComponent from "../common/AutoBindComponent";

import Fieldset from "../common/Fieldset";
import Form from "../common/Form";
import Row from "../common/Row";
import Section from "../common/Section";
import { bindActionCreators } from "redux";
import * as layoutActions from "../../actions/layoutActions";
import * as types from "../../constants/ComponentConstants";
import classnames from "classnames";

class IndienenBevestigingPage extends AutoBindComponent {
	constructor(props, context) {
		super(props, context);

		this.state = {
		};
	}

	componentWillMount() {
		const ingediend = this.props.indienen;
		this.props.loadLayout(ingediend.dossierId, ingediend.dossierNaam, ingediend.tabTitle);
	}

	render() {
		return (
			<Section title="Dien in" color={types.COLOR_GREEN}>
				<Form title="Bevestigingsformulier" name="Bevestigingsformulier" isNotRequired>
					<Fieldset>
						<Row>
							<p>Het dossier is verwerkt.<br />
							Je kunt geen wijzigingen meer aanbrengen.</p>							
							<br />
						</Row>
						<Row>
							<div style={{color: 'orange'}}>
								<div className="o-col-1" style={{ textAlign: 'center' }}>
									<i className={"fa " + classnames(types.FONT_ICON_EXCLAMATION)} style={{ fontSize: '2em' }}/>{'   '}
								</div>
								<div className="o-col-11">
									<span style={{ fontSize: '.875rem'}}>
                                    Een PDF werd ter ondertekening verstuurd naar het e-mail-adres van de contactpersonen.<br />
                                    Let op: je dient ons nog een gehandtekende hardcopy te bezorgen om volledig te zijn. De bijlagen moeten <span className="text-underline ">niet</span> worden nagestuurd.<br/>
                                    Scan de gehandtekende hardcopy in en stuur deze naar <a className="minimal" href="mailto:infrastructuur@sport.vlaanderen">infrastructuur@sport.vlaanderen</a>.
									</span>			
								</div>					
							</div>				
						</Row>
					</Fieldset>
				</Form>
			</Section >
		);
	}
}

// ----------------------------------------------------------------------------

IndienenBevestigingPage.propTypes = {
	loadLayout: PropTypes.func
};


function mapStateToProps(state, ownProps) {
	return {
		indienen: state.indienen
	};
}
function mapDispatchToProps(dispatch) {
	return {
		loadLayout: bindActionCreators(layoutActions.loadIndienenBevestigingPageLayout, dispatch)
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(IndienenBevestigingPage);
